/**
 * Font constants and utilities for the editor
 * Provides a curated set of Google Fonts for document styling
 */

export interface ICuratedFont {
  name: string;
  fontFamily: string;
  googleFontsId: string;
  category: CuratedFontCategory;
}

export enum CuratedFontCategory {
  Serif = 'serif',
  SansSerif = 'sans-serif',
}

export const CURATED_FONTS: ICuratedFont[] = [
  {
    name: 'Roboto',
    fontFamily: 'Roboto',
    googleFontsId: 'Roboto',
    category: CuratedFontCategory.SansSerif,
  },
  {
    name: 'Open Sans',
    fontFamily: 'Open Sans',
    googleFontsId: 'Open+Sans',
    category: CuratedFontCategory.SansSerif,
  },
  {
    name: 'Lato',
    fontFamily: 'Lato',
    googleFontsId: 'Lato',
    category: CuratedFontCategory.SansSerif,
  },
  {
    name: 'Merriweather',
    fontFamily: 'Merriweather',
    googleFontsId: 'Merriweather',
    category: CuratedFontCategory.Serif,
  },
  {
    name: 'Arimo',
    fontFamily: 'Arimo',
    googleFontsId: 'Arimo',
    category: CuratedFontCategory.SansSerif,
  },
  {
    name: 'Source Serif 4',
    fontFamily: 'Source Serif 4',
    googleFontsId: 'Source+Serif+4',
    category: CuratedFontCategory.Serif,
  },
  {
    name: 'Tinos',
    fontFamily: 'Tinos',
    googleFontsId: 'Tinos',
    category: CuratedFontCategory.Serif,
  },
];

/**
 * Builds a Google Fonts CSS2 URL for the provided fonts
 * Each font gets weights 300, 400, 500, 700
 * @param fonts Array of curated fonts to include
 * @returns CSS2 URL string for loading Google Fonts
 */
export function buildGoogleFontsUrl(fonts: ICuratedFont[]): string {
  const fontParams = fonts
    .map((font) => `family=${font.googleFontsId}:wght@300;400;500;700`)
    .join('&');

  return `https://fonts.googleapis.com/css2?${fontParams}&display=swap`;
}

export const DEFAULT_FONT_FAMILY = 'Roboto';
